import { jsx as _jsx } from "react/jsx-runtime";
import { IonPage, IonContent } from "@ionic/react";
import { ShopWidget } from "@dieta-social/shop-widget";
import { useEffect, useMemo } from "react";
import "./HostPage.css";
const STORAGE_KEYS = {
    apiBaseUrl: "shopWidget.apiBaseUrl",
    authToken: "shopWidget.authToken",
    basePath: "shopWidget.basePath",
};
/** A value the page was rendered with wins; the saved one only fills a gap. */
const preferServer = (serverValue, key) => {
    if (serverValue !== undefined && serverValue !== "") {
        return serverValue;
    }
    try {
        const stored = localStorage.getItem(key);
        return stored !== null && stored !== "" ? stored : serverValue;
    }
    catch {
        return serverValue;
    }
};
export default function HostPage({ apiBaseUrl, authToken, basePath, logoutUrl }) {
    // «Esci» (client, 30/10/2026). The Shop has already dropped its own sign-in;
    // forget any token this page stored and let the server end the website
    // session, which brings the visitor back to the Shop home signed out.
    const handleLogout = useMemo(() => {
        if (!logoutUrl) {
            return undefined;
        }
        return () => {
            try {
                localStorage.removeItem(STORAGE_KEYS.authToken);
            }
            catch {
                // Storage disabled: nothing stored to forget.
            }
            window.location.assign(logoutUrl);
        };
    }, [logoutUrl]);
    const resolvedApiBaseUrl = useMemo(() => preferServer(apiBaseUrl, STORAGE_KEYS.apiBaseUrl) ?? "", [apiBaseUrl]);
    // The sign-in comes from the server session on every page load (client,
    // 23/10/2026: a logged-in member found an empty checkout). A token saved
    // earlier used to win over it — an empty one from a logged-out visit, or
    // another account's — so the Shop treated the member as anonymous. It is no
    // longer saved; without a session the widget's own «Accedi» signs in.
    const resolvedAuthToken = authToken ?? "";
    const resolvedBasePath = useMemo(() => preferServer(basePath, STORAGE_KEYS.basePath) ?? "/", [basePath]);
    useEffect(() => {
        try {
            localStorage.removeItem(STORAGE_KEYS.authToken);
            localStorage.setItem(STORAGE_KEYS.apiBaseUrl, resolvedApiBaseUrl);
            localStorage.setItem(STORAGE_KEYS.basePath, resolvedBasePath);
        }
        catch {
            // Ignore write failures (e.g. private browsing or disabled storage).
        }
    }, [resolvedApiBaseUrl, resolvedBasePath]);
    return (_jsx(IonPage, { children: _jsx(IonContent, { className: "ion-padding", children: _jsx("div", { className: "page-container", children: _jsx(ShopWidget, { authToken: resolvedAuthToken, basePath: resolvedBasePath, apiBaseUrl: resolvedApiBaseUrl, onLogout: handleLogout }) }) }) }));
}
